import type { IRemoveProfile } from './index.h'

import {
  TextBoxMaxLine2FontXs,
  TextBoxMaxLine3Font2XlBold,
} from 'atoms/TextBox/Templates'
import { AvatarProfileBlock } from 'blocks/AvatarBlock/Templates'
import {
  RemoveProfileContentSC,
  RemoveProfileSC,
  RemoveProfileWrapper,
} from './RemoveProfile.styled'

export const RemoveProfile = ({
  children,
  title,
  subtitle,
  avatarTitle,
  avatar,
}: IRemoveProfile) => {
  return (
    <RemoveProfileSC>
      <AvatarProfileBlock title={avatarTitle} avatar={avatar} />
      <RemoveProfileContentSC>
        <TextBoxMaxLine3Font2XlBold title={title} />
        <RemoveProfileWrapper>
          <TextBoxMaxLine2FontXs title={subtitle} />
          {children}
        </RemoveProfileWrapper>
      </RemoveProfileContentSC>
    </RemoveProfileSC>
  )
}
